import { CollectionActions } from '../constants/Collection';

export function addCollectionItem({ pandoraId, pandoraType, stationId }) {
  return {
    type: CollectionActions.ADD_COLLECTION_ITEM,
    data: {
      pandoraId,
      pandoraType,
      stationId,
    },
  };
}

export function removeCollectionItem({
  pandoraId,
  pandoraType,
  stationId,
  redirectToMyMusic,
  redirectToMyMusicPlaylists,
  componentName,
}) {
  return {
    type: CollectionActions.REMOVE_COLLECTION_ITEM,
    data: {
      pandoraId,
      pandoraType,
      stationId,
      redirectToMyMusic,
      redirectToMyMusicPlaylists,
      componentName,
    },
  };
}

export function getVersion() {
  return {
    type: CollectionActions.GET_COLLECTION_VERSION,
  };
}

export function confirmRemoveStationFromCollection({
  stationId,
  redirectToMyMusic,
  componentName,
}) {
  return {
    type: CollectionActions.REMOVE_STATION_FROM_COLLECTION,
    data: {
      stationId,
      redirectToMyMusic,
      componentName,
    },
  };
}

export function getSortedCollectionItems({ filter, sortOrder, offset, limit, annotationLimit }) {
  return {
    type: CollectionActions.GET_COLLECTION_SORTED_ITEMS,
    data: {
      filter,
      sortOrder,
      offset,
      limit,
      annotationLimit,
    },
  };
}

export function setCollectionCurrentFilter(filter) {
  return {
    type: CollectionActions.SET_COLLECTION_CURRENT_FILTER,
    data: {
      filter,
    },
  };
}

export function getItemsByArtist({ artistPandoraId, annotationLimit }) {
  return {
    type: CollectionActions.GET_COLLECTION_ITEMS_BY_ARTIST,
    data: {
      artistPandoraId,
      annotationLimit,
    },
  };
}

/**
 *
 * @param {string} sort The persisted sorting value ('ALPHA', 'MOST_RECENT_ADDED', etc)
 * @param {string} newDisplayType A value consumed by onCollectionListSorted worker saga and dispatched to logEvents for sorting analytics
 * @returns {{data: {newDisplayType: string, sort: string}, type: string}}
 */
export function setCollectionCurrentFilterSort({ sort, newDisplayType }) {
  return {
    type: CollectionActions.SET_COLLECTION_CURRENT_FILTER_SORT,
    data: {
      sort,
      newDisplayType,
    },
  };
}
